import {toast} from "vue3-toastify";

const state = {
    dispatchToastWhenMounted: false,
    dispatchToastBetweenRoutes: false,
    toastTypeToDispatch: null,
    toastMessage: null
}

const getters = {
    getDispatchToastBetweenRoutes: (state) => state.dispatchToastBetweenRoutes,
    getDispatchToastWhenMountedState: (state) => state.dispatchToastWhenMounted,
    getToastDataToDispatch: (state) => ({ type: state.toastTypeToDispatch, message: state.toastMessage  })
}

const mutations = {
    setToastDataToDispatchBetweenRoutes(state, data) {
        state.dispatchToastBetweenRoutes = !!data
        state.toastTypeToDispatch = data?.type || null
        state.toastMessage = data?.message ||  null
    },

    setToastDataToDispatchWhenMounted(state, data) {
        state.dispatchToastWhenMounted = !!data
        state.toastTypeToDispatch = data?.type || null
        state.toastMessage = data?.message ||  null
    }
}

const actions = {
    setToastDataToDispatchBetweenRoutes({commit}, data) {
        commit('setToastDataToDispatchBetweenRoutes', data)
    },

    setToastDataToDispatchWhenMounted({commit}, data) {
        commit('setToastDataToDispatchWhenMounted', data)
    },

    activeErrorNotification ({commit}, payload) {
        toast.error(payload.text, {
            position: 'top-right',
            theme: 'colored',
            ...payload.customTimeLimit && {autoClose: payload.customTimeLimit}
        })
    },
    activeSuccesNotification ({commit}, payload) {
        toast.success(payload.text, {
            position: 'top-right',
            theme: 'colored',
            ...payload.customTimeLimit && {autoClose: payload.customTimeLimit}
        })
    },

    activeInfoNotification ({commit}, payload) {
        toast.info(payload.text, {
            position: 'top-right',
            theme: 'colored'
        })
    },
}

export default  {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}